import { ProjectRoleType } from '@platform/client/schemas';
import { DisplayDataForRoleType } from '../util';

export const VolunteerRolePanel = ({ roleType }: { roleType: ProjectRoleType }) => {
  const panelData = DisplayDataForRoleType[roleType];
  return (
    <div className='bg-warning-25 rounded-xl border border-gray-100 p-4 w-fit h-fit'>
      <div className='flex items-center gap-4'>
        <div className='w-14 h-14'>{panelData.icon()}</div>
        <div>
          <div className='text-sm font-medium text-gray-500'>Volunteer role</div>
          <div className='text-xl font-semibold text-gray-600'>{panelData.label}</div>
        </div>
      </div>
      <div className='mt-4'>{panelData.description}</div>
    </div>
  );
};
